import { observer } from 'mobx-react-lite'
import {
  type IMiniContactCardProps,
  MiniContactCard,
} from 'entities/Contacts/ui/ContactCard/MiniContactCard/MiniContactCard'
import {
  DefaultContactCard,
  type IDefaultContactCard,
} from 'entities/Contacts/ui/ContactCard/DefaultContactCard/DefaultContactCard'
import type { IContactAll } from 'entities/Contacts'

type IContactCardProps<T> = IDefaultContactCard<T> | IMiniContactCardProps<T>

export const ContactCard = observer(<T extends IContactAll>(props: IContactCardProps<T>) => {
  if (props.size === 'mini') {
    return <MiniContactCard {...props} />
  }
  return <DefaultContactCard {...props} />
})
